import { config, handleResponse } from '../../_helpers';

export const branchService = {
    getAllBranches,
    getBranchById,
    createBranch,
    updateBranch,
    deleteBranch,
    activation,
    getActiveBranches,
    getBranchIdFromBase,
};

function getAllBranches(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/Branches/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/Branches/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getBranchById(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Branches/get/${code}`, requestOptions).then(handleResponse);
}
function createBranch(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Branches`, requestOptions).then(handleResponse);
}
function updateBranch(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Branches/update/${id}`, requestOptions).then(handleResponse);
}
function deleteBranch(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Branches/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/Branches/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function getActiveBranches() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Branches/getIsActive`, requestOptions).then(handleResponse);
}
function getBranchIdFromBase(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Branches/getBranchIdFromBase`, requestOptions).then(handleResponse);
}